module.exports = {
	"ha": "vcha",
	"id": 5.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category and MSM Status, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 93.82716049382715,
						"dataLabels": {
							"enabled": false,
							"format": "76"
						},
						"color": "#043f61"
					},
					{
						"y": 82.71604938271605,
						"dataLabels": {
							"enabled": false,
							"format": "67"
						},
						"color": "#0c4250"
					},
					{
						"y": 81.48148148148148,
						"dataLabels": {
							"enabled": false,
							"format": "66"
						},
						"color": "#0d4440"
					},
					{
						"y": 75.30864197530865,
						"dataLabels": {
							"enabled": false,
							"format": "61"
						},
						"color": "#09472e"
					},
					{
						"y": 65.4320987654321,
						"dataLabels": {
							"enabled": false,
							"format": "53"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.72619047619048,
						"dataLabels": {
							"enabled": false,
							"format": "325"
						},
						"color": "#043f61"
					},
					{
						"y": 82.44047619047619,
						"dataLabels": {
							"enabled": false,
							"format": "277"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.86904761904762,
						"dataLabels": {
							"enabled": false,
							"format": "265"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.83333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "238"
						},
						"color": "#09472e"
					},
					{
						"y": 55.35714285714286,
						"dataLabels": {
							"enabled": false,
							"format": "186"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.23857868020305,
						"dataLabels": {
							"enabled": false,
							"format": "391"
						},
						"color": "#043f61"
					},
					{
						"y": 86.29441624365482,
						"dataLabels": {
							"enabled": false,
							"format": "340"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.45685279187818,
						"dataLabels": {
							"enabled": false,
							"format": "317"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.60406091370558,
						"dataLabels": {
							"enabled": false,
							"format": "290"
						},
						"color": "#09472e"
					},
					{
						"y": 55.58375634517766,
						"dataLabels": {
							"enabled": false,
							"format": "219"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "1510"
						},
						"color": "#043f61"
					},
					{
						"y": 90.19867549668874,
						"dataLabels": {
							"enabled": false,
							"format": "1362"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.56291390728477,
						"dataLabels": {
							"enabled": false,
							"format": "1292"
						},
						"color": "#0d4440"
					},
					{
						"y": 81.72185430463577,
						"dataLabels": {
							"enabled": false,
							"format": "1234"
						},
						"color": "#09472e"
					},
					{
						"y": 65.62913907284769,
						"dataLabels": {
							"enabled": false,
							"format": "991"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "23"
						},
						"color": "#0c4250"
					},
					{
						"y": 95.65217391304348,
						"dataLabels": {
							"enabled": false,
							"format": "22"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.91304347826086,
						"dataLabels": {
							"enabled": false,
							"format": "17"
						},
						"color": "#09472e"
					},
					{
						"y": 52.17391304347826,
						"dataLabels": {
							"enabled": false,
							"format": "12"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.47328244274809,
						"dataLabels": {
							"enabled": false,
							"format": "129"
						},
						"color": "#043f61"
					},
					{
						"y": 93.89312977099237,
						"dataLabels": {
							"enabled": false,
							"format": "123"
						},
						"color": "#0c4250"
					},
					{
						"y": 85.49618320610686,
						"dataLabels": {
							"enabled": false,
							"format": "112"
						},
						"color": "#0d4440"
					},
					{
						"y": 67.17557251908397,
						"dataLabels": {
							"enabled": false,
							"format": "88"
						},
						"color": "#09472e"
					},
					{
						"y": 43.51145038167939,
						"dataLabels": {
							"enabled": false,
							"format": "57"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.88888888888889,
						"dataLabels": {
							"enabled": false,
							"format": "267"
						},
						"color": "#043f61"
					},
					{
						"y": 86.29629629629629,
						"dataLabels": {
							"enabled": false,
							"format": "233"
						},
						"color": "#0c4250"
					},
					{
						"y": 81.48148148148148,
						"dataLabels": {
							"enabled": false,
							"format": "220"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.48148148148148,
						"dataLabels": {
							"enabled": false,
							"format": "193"
						},
						"color": "#09472e"
					},
					{
						"y": 40.74074074074074,
						"dataLabels": {
							"enabled": false,
							"format": "110"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "746"
						},
						"color": "#043f61"
					},
					{
						"y": 94.63806970509383,
						"dataLabels": {
							"enabled": false,
							"format": "706"
						},
						"color": "#0c4250"
					},
					{
						"y": 89.27613941018767,
						"dataLabels": {
							"enabled": false,
							"format": "666"
						},
						"color": "#0d4440"
					},
					{
						"y": 81.36729222520107,
						"dataLabels": {
							"enabled": false,
							"format": "607"
						},
						"color": "#09472e"
					},
					{
						"y": 50.67024128686327,
						"dataLabels": {
							"enabled": false,
							"format": "378"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 46.601941747572816,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#043f61"
					},
					{
						"y": 41.74757281553398,
						"dataLabels": {
							"enabled": false,
							"format": "43"
						},
						"color": "#0c4250"
					},
					{
						"y": 37.86407766990291,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#0d4440"
					},
					{
						"y": 33.00970873786408,
						"dataLabels": {
							"enabled": false,
							"format": "34"
						},
						"color": "#09472e"
					},
					{
						"y": 15.53398058252427,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.11764705882352,
						"dataLabels": {
							"enabled": false,
							"format": "160"
						},
						"color": "#043f61"
					},
					{
						"y": 79.41176470588235,
						"dataLabels": {
							"enabled": false,
							"format": "135"
						},
						"color": "#0c4250"
					},
					{
						"y": 74.11764705882354,
						"dataLabels": {
							"enabled": false,
							"format": "126"
						},
						"color": "#0d4440"
					},
					{
						"y": 67.05882352941175,
						"dataLabels": {
							"enabled": false,
							"format": "114"
						},
						"color": "#09472e"
					},
					{
						"y": 49.411764705882355,
						"dataLabels": {
							"enabled": false,
							"format": "84"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.95959595959596,
						"dataLabels": {
							"enabled": false,
							"format": "285"
						},
						"color": "#043f61"
					},
					{
						"y": 76.43097643097643,
						"dataLabels": {
							"enabled": false,
							"format": "227"
						},
						"color": "#0c4250"
					},
					{
						"y": 68.01346801346801,
						"dataLabels": {
							"enabled": false,
							"format": "202"
						},
						"color": "#0d4440"
					},
					{
						"y": 62.62626262626263,
						"dataLabels": {
							"enabled": false,
							"format": "186"
						},
						"color": "#09472e"
					},
					{
						"y": 50.841750841750844,
						"dataLabels": {
							"enabled": false,
							"format": "151"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.1563981042654,
						"dataLabels": {
							"enabled": false,
							"format": "820"
						},
						"color": "#043f61"
					},
					{
						"y": 70.97156398104265,
						"dataLabels": {
							"enabled": false,
							"format": "599"
						},
						"color": "#0c4250"
					},
					{
						"y": 64.81042654028435,
						"dataLabels": {
							"enabled": false,
							"format": "547"
						},
						"color": "#0d4440"
					},
					{
						"y": 61.61137440758294,
						"dataLabels": {
							"enabled": false,
							"format": "520"
						},
						"color": "#09472e"
					},
					{
						"y": 50.82938388625592,
						"dataLabels": {
							"enabled": false,
							"format": "429"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -6.172839506172845,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.842105263157897,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.4925373134328401,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.57575757575758,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.11475409836066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.2738095238095233,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.769230769230768,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.332129963898912,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.188679245283016,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.84873949579832,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.761421319796951,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.043478260869568,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.764705882352939,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.517350157728709,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.48275862068966,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.80132450331126,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.139500734214386,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.489164086687303,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.69205834683955,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.347826086956519,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.72727272727273,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.411764705882348,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.526717557251911,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.651162790697672,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.943089430894313,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -21.42857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -35.22727272727273,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.1111111111111072,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.734082397003743,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.579399141630903,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.272727272727268,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -43.005181347150256,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.36193029490617,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.6657223796034,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.858858858858854,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -37.72652388797364,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -53.398058252427184,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.416666666666663,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.302325581395355,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.82051282051282,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -52.94117647058824,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.315789473684216,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.040404040404044,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.350877192982452,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.013215859030833,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.920792079207917,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.817204301075275,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.843601895734593,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.951219512195124,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.681135225375625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.936014625228524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.500000000000004,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=81"
			},
			{
				"x": 9,
				"text": "30-39<br>n=336"
			},
			{
				"x": 15,
				"text": "40-49<br>n=394"
			},
			{
				"x": 21,
				"text": ">=50<br>n=1510"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=23"
			},
			{
				"x": 34,
				"text": "30-39<br>n=131"
			},
			{
				"x": 40,
				"text": "40-49<br>n=270"
			},
			{
				"x": 46,
				"text": ">=50<br>n=746"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=103"
			},
			{
				"x": 59,
				"text": "30-39<br>n=170"
			},
			{
				"x": 65,
				"text": "40-49<br>n=297"
			},
			{
				"x": 71,
				"text": ">=50<br>n=844"
			}
		],
		"dataTable": {
			"MSM:<30": [
				81,
				76,
				67,
				66,
				61,
				53
			],
			"MSM:30-39": [
				336,
				325,
				277,
				265,
				238,
				186
			],
			"MSM:40-49": [
				394,
				391,
				340,
				317,
				290,
				219
			],
			"MSM:>=50": [
				1510,
				1510,
				1362,
				1292,
				1234,
				991
			],
			"Non-MSM:<30": [
				23,
				23,
				23,
				22,
				17,
				12
			],
			"Non-MSM:30-39": [
				131,
				129,
				123,
				112,
				88,
				57
			],
			"Non-MSM:40-49": [
				270,
				267,
				233,
				220,
				193,
				110
			],
			"Non-MSM:>=50": [
				746,
				746,
				706,
				666,
				607,
				378
			],
			"Unknown:<30": [
				103,
				48,
				43,
				39,
				34,
				16
			],
			"Unknown:30-39": [
				170,
				160,
				135,
				126,
				114,
				84
			],
			"Unknown:40-49": [
				297,
				285,
				227,
				202,
				186,
				151
			],
			"Unknown:>=50": [
				844,
				820,
				599,
				547,
				520,
				429
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_5.json
// module id = 306
// module chunks = 0